export default {

  VIEW_DASHBOARD: '',
  VIEW_STATISTIC: 'statistic_view',
  VIEW_USER_PROFILE: null,


  CREATE_CONTACT: 'contact_create',
  VIEW_CONTACT: 'contact_view',
  UPDATE_CONTACT: 'contact_update',
  DELETE_CONTACT: 'contact_delete',
  CONTACT_IMPORT: 'contact_import',
  CONTACT_EXPORT: 'contact_export',
  CONTACT_VIEW_ESTIMATE: 'contact_estimate_view',
  CONTACT_VIEW_INVOICE: 'contact_invoice_view',
  CONTACT_VIEW_OPPORTUNITY: 'contact_opportunity_view',


  CREATE_APPOINTMENT: 'appointment_create',
  VIEW_APPOINTMENT: 'appointment_view',
  VIEW_ALL_APPOINTMENT: 'appointment_view_all',
  UPDATE_APPOINTMENT: 'appointment_update',
  UPDATE_ALL_APPOINTMENT: 'appointment_update_all',
  DELETE_APPOINTMENT: 'appointment_delete',
  DELETE_ALL_APPOINTMENT: 'appointment_delete_all',
  IMPORT_APPOINTMENT: 'appointment_import',
  EXPORT_APPOINTMENT: 'appointment_export',
  SEND_APPOINTMENT: 'appointment_send',
  VIEW_STATS_APPOINTMENT: 'appointment_view_stats',
  CANCEL_APPOINTMENT: 'appointment_cancel',

  CREATE_APPOINTMENT_TYPE: 'appointment_type_create',
  VIEW_APPOINTMENT_TYPE: 'appointment_type_view',
  UPDATE_APPOINTMENT_TYPE: 'appointment_type_update',
  DELETE_APPOINTMENT_TYPE: 'appointment_type_delete',

  CREATE_RECURRING_APPOINTMENT: 'recurring_appointment_create',
  VIEW_RECURRING_APPOINTMENT: 'recurring_appointment_view_all',
  UPDATE_RECURRING_APPOINTMENT: 'recurring_appointment_update',

  CREATE_ESTIMATE: 'estimate_create',
  VIEW_ESTIMATE: 'estimate_view',
  VIEW_ALL_ESTIMATE: 'estimate_view_all',
  UPDATE_ESTIMATE: 'estimate_update',
  UPDATE_ALL_ESTIMATE: 'estimate_update_all',
  DELETE_ESTIMATE: 'estimate_delete',
  DELETE_ALL_ESTIMATE: 'estimate_delete_all',
  IMPORT_ESTIMATE: 'estimate_import',
  EXPORT_ESTIMATE: 'estimate_export',
  PAID_ESTIMATE: 'estimate_paid',
  SEND_ESTIMATE: 'estimate_send',
  VIEW_STATS_ESTIMATE: 'estimate_view_stats',
  PRINT_ESTIMATE: 'estimate_print',
  DOWNLOAD_ESTIMATE: 'estimate_download',

  CREATE_INVOICE: 'invoice_create',
  VIEW_INVOICE: 'invoice_view',
  VIEW_ALL_INVOICE: 'invoice_view_all',
  UPDATE_INVOICE: 'invoice_update',
  UPDATE_ALL_INVOICE: 'invoice_update_all',
  DELETE_INVOICE: 'invoice_delete',
  IMPORT_INVOICE: 'invoice_import',
  EXPORT_INVOICE: 'invoice_export',
  PAID_INVOICE: 'invoice_paid',
  SEND_INVOICE: 'invoice_send',
  VIEW_STATS_INVOICE: 'invoice_view_stats',
  ARCHIVE_INVOICE: 'invoice_archive',
  PRINT_INVOICE: 'invoice_print',
  DOWNLOAD_INVOICE: 'invoice_download',
  NORMALIZE_INVOICE: 'invoice_normalize',
  CREDIT_INVOICE: 'invoice_credit',

  CREATE_PAYMENT: 'payment_create',
  VIEW_PAYMENT: 'payment_view',
  VIEW_ALL_PAYMENT: 'payment_view_all',
  UPDATE_PAYMENT: 'payment_update',
  DELETE_PAYMENT: 'payment_delete',
  IMPORT_PAYMENT: 'payment_import',
  EXPORT_PAYMENT: 'payment_export',
  PAID_PAYMENT: 'payment_paid',
  SEND_PAYMENT: 'payment_send',
  CANCEL_PAYMENT: 'payment_cancel',
  PRINT_PAYMENT: 'payment_print',
  DOWNLOAD_PAYMENT: 'payment_download',

  CREATE_RECURRING_INVOICE: 'recurring_invoice_create',
  VIEW_RECURRING_INVOICE: 'recurring_invoice_view',
  VIEW_ALL_RECURRING_INVOICE: 'recurring_invoice_view_all',
  UPDATE_RECURRING_INVOICE: 'recurring_invoice_update',
  UPDATE_ALL_RECURRING_INVOICE: 'recurring_invoice_update_all',

  CREATE_OPPORTUNITIES: 'opportunities_create',
  VIEW_OPPORTUNITIES: 'opportunities_view',
  VIEW_ALL_OPPORTUNITIES: 'opportunities_view_all',
  UPDATE_OPPORTUNITIES: 'opportunities_update',
  UPDATE_ALL_OPPORTUNITIES: 'opportunities_update_all',
  DELETE_OPPORTUNITIES: 'opportunities_delete',
  ARCHIVE_OPPORTUNITIES: 'opportunities_archive',
  EXPORT_OPPORTUNITIES: 'opportunities_export',
  VIEW_STATS_OPPORTUNITIES: 'opportunities_stats',
  VIEW_PREVISION_OPPORTUNITIES: 'opportunities_prevision_view',
  VIEW_ESTIMATE_OPPORTUNITIES: 'opportunities_estimate_view',
  VIEW_INVOICE_OPPORTUNITIES: 'opportunities_invoice_view',
  GENERATE_ESTIMATE_OPPORTUNITIES: 'opportunities_generate_estimate',
  GENERATE_INVOICE_OPPORTUNITIES: 'opportunities_generate_invoice',
  OPPORTUNITIES_STATE_CHANGE: "opportunities_state_change",

  CREATE_ACTIVITY: 'activity_create',
  VIEW_ACTIVITY: 'activity_view',
  UPDATE_ACTIVITY: 'activity_update',
  DELETE_ACTIVITY: 'activity_delete',

  CREATE_OPPORTUNITY_STATE: 'opportunity_state_create',
  VIEW_OPPORTUNITY_STATE: 'opportunity_state_view',
  UPDATE_OPPORTUNITY_STATE: 'opportunity_state_update',
  DELETE_OPPORTUNITY_STATE: 'opportunity_state_delete',

  CREATE_REASON: 'reason_create',
  VIEW_REASON: 'reason_view',
  UPDATE_REASON: 'reason_update',
  DELETE_REASON: 'reason_delete',

  CREATE_TYPE_ACTIVITY: 'type_activity_create',
  VIEW_TYPE_ACTIVITY: 'type_activity_view',
  UPDATE_TYPE_ACTIVITY: 'type_activity_update',
  DELETE_TYPE_ACTIVITY: 'type_activity_delete',

  CREATE_TAG: 'tag_create',
  VIEW_TAG: 'tag_view',
  UPDATE_TAG: 'tag_update',
  DELETE_TAG: 'tag_delete',

  CREATE_TAX: 'taxe_create',
  VIEW_TAX : 'taxe_view',
  UPDATE_TAX: 'taxe_update',
  DELETE_TAX: 'taxe_delete',

  CREATE_POST_OFFICE: 'post_office_create',
  VIEW_POST_OFFICE: 'post_office_view',
  UPDATE_POST_OFFICE: 'post_office_update',
  DELETE_POST_OFFICE: 'post_office_delete',

  CREATE_ATTRIBUT: 'attribut_create',
  VIEW_ATTRIBUT: 'attribut_view',
  UPDATE_ATTRIBUT: 'attribut_update',
  DELETE_ATTRIBUT: 'attribut_delete',

  CREATE_BRAND: 'brand_create',
  VIEW_BRAND: 'brand_view',
  UPDATE_BRAND: 'brand_update',
  DELETE_BRAND: 'brand_delete',

  CREATE_CATEGORY: 'category_create',
  VIEW_CATEGORY: 'category_view',
  UPDATE_CATEGORY: 'category_update',
  DELETE_CATEGORY: 'category_delete',

  CREATE_PRODUCT: 'product_create',
  VIEW_PRODUCT: 'product_view',
  UPDATE_PRODUCT: 'product_update',
  DELETE_PRODUCT: 'product_delete',
  IMPORT_PRODUCT: 'product_import',
  EXPORT_PRODUCT: 'product_export',

  CREATE_VARIATION: 'variation_create',
  VIEW_VARIATION: 'variation_view',
  UPDATE_VARIATION: 'variation_update',
  DELETE_VARIATION: 'variation_delete',

  CREATE_PAYMENT_CONDITION: 'payment_condition_create',
  VIEW_PAYMENT_CONDITION: 'payment_condition_view',
  UPDATE_PAYMENT_CONDITION: 'payment_condition_update',
  DELETE_PAYMENT_CONDITION: 'payment_condition_delete',

  CREATE_PAYMENT_TYPE: 'payment_type_create',
  VIEW_PAYMENT_TYPE: 'payment_type_view',
  UPDATE_PAYMENT_TYPE: 'payment_type_update',
  DELETE_PAYMENT_TYPE: 'payment_type_delete',

  CREATE_PROFILE: 'profiles_create',
  VIEW_PROFILE: 'profiles_view',
  UPDATE_PROFILE: 'profiles_update',
  DELETE_PROFILE: 'profiles_delete',

  CREATE_USER: 'users_create',
  VIEW_USER: 'users_view',
  VIEW_ALL_USER: 'users_view_all',
  UPDATE_USER: 'users_update',
  UPDATE_ALL_USER: 'users_update_all',
  DELETE_USER: 'users_delete',
  DELETE_ALL_USER: 'users_delete_all',
  IMPORT_USER: 'users_import',
  EXPORT_USER: 'users_export',
  USER_PERMISSION: 'users_permission',

  CREATE_RIGHT: 'right_create',
  VIEW_RIGHT: 'right_view',
  UPDATE_RIGHT: 'right_update',
  DELETE_RIGHT: 'right_delete',
  RIGHT_PERMISSION: 'right_permission_view',

  VIEW_DEPARTMENT: 'department_view',
  CREATE_DEPARTMENT: 'department_create',
  UPDATE_DEPARTMENT: 'department_update',
  DELETE_DEPARTMENT: 'department_delete',


  EMAIL_CONFIG_VIEW :  'smtp_view',
  EMAIL_CONFIG_CREATE : 'smtp_create',


  EMAIL_MESSAGE_VIEW :  'email_message_view',
  EMAIL_MESSAGE_CREATE : 'email_message_create',
  EMAIL_MESSAGE_UPDATE : 'email_message_update',
  EMAIL_MESSAGE_DELETE : 'email_message_delete',

  REMIND_CONFIG_VIEW :  'frequency_view',
  REMIND_CONFIG_CREATE : 'frequency_create',

  TEMPLATE_CONFIG_VIEW :  null,


  VIEW_SETTINGS :  ['taxe_view','users_view','right_view','department_view','reason_view',
    'opportunity_state_view','type_activity_view','appointment_type_view','payment_type_view',
    'payment_condition_view','email_message_view','smtp_view','post_office_view','tag_view'
  ],
  VIEW_GENERAL_SETTINGS :  [ 'company_view','taxe_view','users_view','right_view','department_view',
    'payment_type_view', 'payment_condition_view','email_message_view','smtp_view',
    null,'post_office_view',
  ],
  COMPANY_SETTING : [null,'taxe_view','department_view','post_office_view'],
  MULTI_COMPANY_SETTING : ['company_view','company_view','email_message_view', 'smtp_view'],
  USER_SETTING: ['users_view', 'right_view'],
  SYSTEM_SETTING: [ 'payment_type_view', 'payment_condition_view','email_message_view','smtp_view',null],
  VIEW_CRM_SETTINGS :  [ 'reason_view', 'opportunity_state_view','type_activity_view','appointment_type_view','tag_view'],
  VIEW_PIPELINE_SETTINGS :  [ 'reason_view', 'opportunity_state_view','type_activity_view','tag_view'],
  VIEW_APPOINTMENT_SETTINGS :  ['appointment_type_view'],
  VIEW_CRM :  ['opportunities_view','opportunities_view_all','estimate_view','estimate_view_all', 'appointment_view','appointment_view_all',
    'payment_view', 'payment_view_all', 'appointment_view_stats', 'opportunities_stats', 'appointment_view_stats',
    'estimate_view_stats'
  ],
  VIEW_FINANCE : [
    'account_view', 'box_view', 'expense_approved', 'expense_validate', 'expense_approved', 'expense_pay'
  ],
  VIEW_DOCUMENT : 'file_manager_view',
  VIEW_RH : ['holiday_view', 'payslips_view', 'employee_contract_view'],
  VIEW_FINANCE_SETTINGS: ['reason_view', 'expense_recurrence_view'],
  VIEW_EXPENSE_SETTINGS: ['reason_view', 'expense_recurrence_view'],
  VIEW_RH_SETTINGS: ['pension_view', 'allowance_view', 'other_view', 'payroll_tax_view'],
  VIEW_PAYSLIP_SETTINGS: ['pension_view', 'allowance_view', 'other_view', 'payroll_tax_view'],
  VIEW_PROJECT_SETTINGS : ['view_categories','view_milestone', 'create_milestone','create_milestone','update_milestone','delete_milestone','view_column','create_column','update_column','delete_column',
    'view_priority','create_priority', 'update_priority', 'delete_priority', 'view_categories', 'create_categories', 'update_categories','delete_categories'
  ],
  VIEW_QVCT_SURVEY_SETTINGS : ['view_qvct_survey_category'],
  VIEW_EVENT_SETTINGS : ['event_view', 'event_view_all'],
  ADMIN: 'Admin',

  VIEW_EXPENSE: 'expense_view',
  UPDATE_EXPENSE: 'expense_update',
  DELETE_EXPENSE: 'expense_delete',
  PAID_EXPENSE: 'expense_pay',
  SEND_EXPENSE: 'expense_send',
  VIEW_STATS_EXPENSE: 'expense_view_stats',
  DOWNLOAD_EXPENSE: 'expense_download',
  VALIDATE_EXPENSE: 'expense_validate',
  APPROVED_EXPENSE : 'expense_approved',
  REJECT_EXPENSE : 'expense_approved',

  CREATE_EXPENSE_REPORT : 'expense_create_report',
  CREATE_EXPENSE_OFFICE : 'expense_create_office',
  VIEW_OFFICE_EXPENSE : 'view_office_expense',


  VIEW_EXPENSE_REASON : 'expense_reason_view',
  CREATE_EXPENSE_REASON : 'expense_reason_create',
  UPDATE_EXPENSE_REASON : 'expense_reason_update',
  DELETE_EXPENSE_REASON : 'expense_reason_delete',

  VIEW_EXPENSE_TYPE : 'expense_type_view',


  VIEW_EXPENSE_RECURRING : 'expense_recurrence_view',
  CREATE_EXPENSE_RECURRING : 'expense_recurrence_create',
  UPDATE_EXPENSE_RECURRING : 'expense_recurrence_update',
  DISABLE_EXPENSE_RECURRING : 'expense_recurrence_disable',
  ACTIVATE_EXPENSE_RECURRING : 'expense_recurrence_active',

  CREATE_ACCOUNT: 'account_create',
  VIEW_ACCOUNT: 'account_view',
  UPDATE_ACCOUNT: 'account_update',
  DELETE_ACCOUNT: 'account_delete',
  DEPOSIT_ACCOUNT: 'account_deposit',
  WITHDRAWAL_ACCOUNT: 'account_withdrawal',
  TRANSFER_ACCOUNT: 'account_transfer',
  VIEW_STAT_ACCOUNT: 'account_view_stats',

  CREATE_BOX: 'box_create',
  VIEW_BOX: 'box_view',
  UPDATE_BOX: 'box_update',
  DELETE_BOX: 'box_delete',
  DEPOSIT_BOX: 'box_deposit',
  WITHDRAWAL_BOX: 'box_withdrawal',
  TRANSFER_BOX: 'box_transfer',
  VIEW_STAT_BOX: 'box_view_stats',

  CREATE_HOLIDAY: 'holiday_create',
  VIEW_HOLIDAY: 'holiday_view',
  UPDATE_HOLIDAY: 'holiday_update',
  DELETE_HOLIDAY: 'holiday_delete',
  APPROVE_HOLIDAY: 'holiday_approve',
  VALIDATE_HOLIDAY: 'holiday_validate',
  VIEW_STAT_HOLIDAY: 'holiday_view_stats',
  REJECT_HOLIDAY: 'holiday_reject',
  CANCELLED_HOLIDAY : 'holiday_cancelled',

  CREATE_PUBLIC_HOLIDAY: 'public_holiday_view',
  VIEW_PUBLIC_HOLIDAY: 'public_holiday_create',
  UPDATE_PUBLIC_HOLIDAY: 'public_holiday_update',
  DELETE_PUBLIC_HOLIDAY: 'public_holiday_delete',

  CREATE_HOLIDAY_TYPE: 'holiday_type_view',
  VIEW_HOLIDAY_TYPE: 'holiday_type_create',
  UPDATE_HOLIDAY_TYPE: 'holiday_type_update',
  DELETE_HOLIDAY_TYPE: 'holiday_type_delete',

  VIEW_COMPANY: 'company_view',
  CREATE_COMPANY: 'company_create',
  UPDATE_COMPANY: 'company_update',
  DELETE_COMPANY: 'company_delete',

  CREATE_OFFICE: 'office_create',
  VIEW_OFFICE: 'office_view',
  UPDATE_OFFICE: 'office_update',
  DELETE_OFFICE: 'office_delete',


  VIEW_PAYSLIP : 'payslips_view',
  CREATE_PAYSLIP : 'payslips_create',
  UPDATE_PAYSLIP : 'payslips_update',
  DELETE_PAYSLIP : 'payslips_delete',
  SEND_PAYSLIP : 'payslips_send',
  VALIDATE_PAYSLIP : 'payslips_validate',
  DOWNLOAD_PAYSLIP  : 'download_payslip',
  GENERATE_PAYSLIP  : 'generate_payslip',


  VIEW_ALLOWANCE : 'allowance_view',
  CREATE_ALLOWANCE : 'allowance_create',
  UPDATE_ALLOWANCE : 'allowance_update',
  DELETE_ALLOWANCE : 'allowance_delete',

  VIEW_OTHER : 'other_view',
  CREATE_OTHER : 'other_create',
  UPDATE_OTHER : 'other_update',
  DELETE_OTHER : 'other_delete',

   VIEW_PAYROLL_TAX : 'payroll_tax_view',
   CREATE_PAYROLL_TAX : 'payroll_tax_create',
   UPDATE_PAYROLL_TAX : 'payroll_tax_update',
   DELETE_PAYROLL_TAX : 'payroll_tax_delete',


   VIEW_PENSION : 'pension_view',
   CREATE_PENSION : 'pension_create',
   UPDATE_PENSION : 'pension_update',
   DELETE_PENSION : 'pension_delete',

  
  
   VIEW_EMPLOYEE_CONTRACT : 'employee_contract_view',
   CREATE_EMPLOYEE_CONTRACT : 'employee_contract_create',
   UPDATE_EMPLOYEE_CONTRACT : 'employee_contract_update',
   DELETE_EMPLOYEE_CONTRACT : 'employee_contract_delete',
   STORE_FILE_EMPLOYEE_CONTRACT : 'employee_contract_store_file',
   DOWNLOAD_CONTRACT_EMPLOYEE_CONTRACT : 'employee_contract_download',
   DOWNLOAD_PAYSLIP_EMPLOYEE_CONTRACT : 'employee_contract_download_payslip',


    VIEW_EMPLOYEE : 'employee_view',
    CREATE_EMPLOYEE : 'employee_create',
    UPDATE_EMPLOYEE : 'employee_update',
    DELETE_EMPLOYEE : 'employee_delete',

    VIEW_POST_CATEGORY : 'post_category_view',
    CREATE_POST_CATEGORY : 'post_category_create',
    UPDATE_POST_CATEGORY : 'post_category_update',
    DELETE_POST_CATEGORY : 'post_category_delete',


    VIEW_NORMALIZED_KEY : 'normalized_key_view',
    CREATE_NORMALIZED_KEY : 'normalized_key_create',
    UPDATE_NORMALIZED_KEY : 'normalized_key_update',
    DELETE_NORMALIZED_KEY : 'normalized_key_delete',

   VIEW_NPS : 'nps_view',
   CREATE_NPS : 'nps_create',
   UPDATE_NPS : 'nps_update',
   DELETE_NPS : 'nps_delete',
   SEND_NPS : 'nps_send',
   NPS_STATISTIC : 'nps_statistic',
   VIEW_STATISTIC_NPS : 'nps_view_statistic',

  VIEW_PROJECT: 'project_view',
  CREATE_PROJECT: 'project_create',
  UPDATE_PROJECT: 'project_update',
  DELETE_PROJECT: 'project_delete',
  STATS_PROJECT: 'project_stats',
  REPORT_PROJECT: 'project_reports',

  VIEW_USER_PERFORMANCE : 'view_user_performance',

  STEP_PROJECT_VIEW: 'project_view_step',
  STEP_PROJECT_CREATE: 'project_create_step',
  STEP_PROJECT_UPDATE: 'project_update_step',
  STEP_PROJECT_DELETE: 'project_delete_step',

  TASK_PROJECT_VIEW: 'project_view_task',
  TASK_PROJECT_CREATE: 'project_create_task',
  TASK_PROJECT_UPDATE: 'project_update_task',
  TASK_PROJECT_DELETE: 'project_delete_task',
  TASK_PROJECT_CLOSE: 'project_close_task',


  FOLDER_PROJECT_VIEW: 'project_view_folder',
  FOLDER_PROJECT_CREATE: 'project_create_folder',
  FOLDER_PROJECT_UPDATE: 'project_update_folder',
  FOLDER_PROJECT_DELETE: 'project_delete_folder',

  ADD_PROJECT_USER: 'project_add_user',
  SEND_PROJECT_COMMENT: 'project_send_comment',
  CREATE_PROJECT_CATEGORY: 'view_categories',

  VIEW_MILESTONE: 'view_milestone',
  CREATE_MILESTONE: 'create_milestone',
  UPDATE_MILESTONE: 'update_milestone',
  DELETE_MILESTONE: 'delete_milestone',

  VIEW_COLUMN: 'view_column',
  CREATE_COLUMN: 'create_column',
  UPDATE_COLUMN: 'update_column',
  DELETE_COLUMN: 'delete_column',

  VIEW_PRIORITY: 'view_priority',
  CREATE_PRIORITY: 'create_priority',
  UPDATE_PRIORITY: 'update_priority',
  DELETE_PRIORITY: 'delete_priority',

  VIEW_CATEGORIES: 'view_categories',
  CREATE_CATEGORIES: 'create_categories',
  UPDATE_CATEGORIES: 'update_categories',
  DELETE_CATEGORIES: 'delete_categories', 

  PROJECT_BUDGET_VIEW: 'project_budget_view',
  PROJECT_BUDGET_CREATE: 'project_budget_create',
  PROJECT_BUDGET_ALLOCATE: 'project_budget_allocate',
  PROJECT_BUDGET_HISTORIE_TRANSACTION: 'project_budget_history_transaction',
  PROJECT_BUDGET_DEPOSIT: 'project_budget_deposits',
  PROJECT_BUDGET_WITHDRAWAL: 'project_budget_withdrawal',
  PROJECT_BUDGET_STATISTIC: 'project_budget_statistics',
  PROJECT_BUDGET_TRANSACTION_VIEW: 'project_budget_transaction_view',

  PROJECT_REPORTING_VIEW: 'project_reporting_view',
  PROJECT_REPORTING_CREATE: 'project_reporting_create',
  PROJECT_REPORTING_UPDATE: 'project_reporting_update',
  PROJECT_REPORTING_DELETE: 'project_reporting_delete',
  PROJECT_REPORTING_PUBLISHED: 'project_reporting_published',
  PROJECT_REPORTING_HISTORIE_TRANSACTION: 'project_reporting_history_transaction',
  PROJECT_REPORTING_DEPOSIT: 'project_reporting_deposits',
  
  VIEW_PUBLICATION: 'publication_view',
  CREATE_PUBLICATION: 'publication_create',
  UPDATE_PUBLICATION: 'publication_update',
  DELETE_PUBLICATION: 'publication_delete',
  FILES_PUBLICATION: 'publication_files',
  DOWNLOAD_FILES: 'publication_downloads_files',
  VIEW_COMMENT: 'comment_view',

  VIEW_CHAT: 'chat_view',
  VIEW_MAIL: '',

  VIEW_PROSPECT : 'view_prospect',
  VALIDATE_PROSPECT  : 'validate_prospect',
  REJECT_PROSPECT : 'reject_prospect',

  VIEW_FORMALITIES_PARAMETERS: 'view_formalities_parameters',
  EDIT_FORMALITIES_PARAMETERS: 'edit_formalities_parameters',

  ADD_PROJECT_FORMALITIES: 'add_project_formalities',
  VIEW_PROJECT_FORMALITIES: 'view_project_formalities',
  EDIT_PROJECT_FORMALITIES: 'edit_project_formalities',
  DELETE_PROJECT_FORMALITIES: 'delete_project_formalities',


  CAN_MODERATE : "can_moderate",
  CAN_SCAN : "can_scan",
  CAN_PARTICIPATE : "can_participate",
  CAN_PRESENT : "can_present",
  CAN_SELL_TICKET : "can_sell_ticket",
  CAN_SCAN_TICKET : "can_scan_ticket",

  CAN_VIEW_ATELIER : "atelier_view",
  CAN_CREATE_ATELIER : "atelier_create",
  CAN_UPDATE_ATELIER : "atelier_update",
  CAN_DELETE_ATELIER : "atelier_delete",
  CAN_VIEW_ALL_ATELIER : "atelier_view_all",
  CAN_ADD_PARTICIPANT_TO_ATELIER : "atelier_add_participant",
  CAN_VIEW_EVENT : "event_view",
  CAN_CREATE_EVENT : "event_create",
  CAN_UPDATE_EVENT : "event_update",
  CAN_DELETE_EVENT : "event_delete",
  CAN_VIEW_ALL_EVENT : "event_view_all",

  CAN_ADD_PARTICIPANT_TO_EVENT : "event_add_participant",
  CAN_VIEW_EVENT_PARTICIPANT : "event_add_participant",
  CAN_VIEW_EVENT_ALL_PARTICIPANT : "event_add_participant",
  CAN_UPDATE_EVENT_PARTICIPANT : "event_add_participant",
  CAN_UPDATE_EVENT_PARTICIPANT_STATUS : "event_add_participant",

  CAN_ADD_SUBSCRIPTOR_TO_EVENT : "event_add_participant",
  CAN_VIEW_EVENT_SUBSCRIPTOR : "event_add_participant",
  CAN_VIEW_EVENT_ALL_SUBSCRIPTOR : "event_add_participant",
  CAN_APPROVE_EVENT_SUBSCRIPTOR : "event_add_participant",
  CAN_REJECT_EVENT_SUBSCRIPTOR : "event_add_participant",

  CAN_SEND_EVENT_INVITATAION : "event_send_invitation",
  CAN_IMPORT_EVENT_PARTICIPANT : "event_import_participant",
  CAN_EXPORT_EVENT_PARTICIPANT : "event_export_participant",

  CAN_VIEW_EVENT_FORM : "event_view",
  CAN_CREATE_EVENT_FORM : "event_create",
  CAN_UPDATE_EVENT_FORM : "event_update",
  CAN_DELETE_EVENT_FORM : "event_delete",
  CAN_VIEW_ALL_EVENT_FORM : "event_view_all",

  CAN_CREATE_PARTICPANT_STATUT: "status_create",

  VIEW_EVENT_PARTICIPATORS: '',
  DELETE_PARTICIPATOR: '',
  DELETE_ALL_PARTICIPATOR: '',

  CAN_VIEW_EVENT_STATUS : "status_view",
  CAN_CREATE_EVENT_STATUS : "status_create",
  CAN_UPDATE_EVENT_STATUS : "status_update",
  CAN_DELETE_EVENT_STATUS : "status_delete",

  //QVCT
  CAN_QVCT_SURVEY_CATEGORY_VIEW: 'view_qvct_survey_category',


    //Access Module

    CAN_VIEW_ACCESS_CONFIG : 'config_view',
    CAN_CREATE_ACCESS_CONFIG : 'config_create',
    CAN_UPDATE_ACCESS_CONFIG : 'config_update',
    CAN_DELETE_ACCESS_CONFIG : 'config_delete',

    CAN_VIEW_ACCESS_HISTORICS : 'access_history_view',

    CAN_CARD_CONFIG_VIEW : 'card_config_view',
    CAN_CARD_CONFIG_CREATE : 'card_config_create',
    CAN_CARD_CONFIG_UPDATE : 'card_config_update',
    CAN_CARD_CONFIG_DELETE : 'card_config_delete',
    CAN_CARD_CONFIG_ASSIGN : 'card_config_assign',
    CAN_CARD_CONFIG_UNASSIGN : 'card_config_unassign',
    CAN_CARD_CONFIG_STATUS_CHANGE : 'card_config_status',
    CAN_CARD_CONFIG_HISTORY_VIEW : 'card_config_history',
    CAN_CARD_CONFIGURE: 'card_config_configure',

    CAN_CREATE_PERIMETER : 'perimeter_create',
    CAN_VIEW_PERIMETER : 'perimeter_view',
    CAN_UPDATE_PERIMETER : 'perimeter_update',
    CAN_DELETE_PERIMETER : 'perimeter_delete',
    CAN_IMPORT_PERIMETER : 'perimeter_import',

    CAN_CREATE_DOOR : 'door_create',
    CAN_VIEW_DOOR : 'door_view',
    CAN_UPDATE_DOOR : 'door_update',
    CAN_DELETE_DOOR : 'door_delete',
    CAN_IMPORT_DOOR : 'door_import',



}
